import { FuuzeError } from './fuuze-error.js';

export class NonPopulatedError extends FuuzeError {
  constructor(data?: string) {
    console.error(
      `Non populated data found: ${data}. You should populate the data before returning it from the server`,
    );
    super(
      'model/non-populated',
      400,
      `Non populated data found: ${data}. You should populate the data before returning it from the server`,
    );
  }
}
